import {CanActivateFn, Router} from '@angular/router';
import { inject } from '@angular/core';
import {AuthStateService} from "../states/auth-state.service";

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(AuthStateService);
  const router = inject(Router);

  if (!userService.isLoggedIn()) {
    router.navigate(['login']); // Redirige a la página de login si no está autenticado
    return false;
  }

  // El alumno no entra al dashboard de administración: a su área.
  if (userService.isStudent()) {
    router.navigateByUrl('/alumno');
    return false;
  }

  return true;
};
